let timerID: NodeJS.Timer;

export function ResetTimer(duration: number, callback: () => void) {
    clearTimeout(timerID);
    if (duration > 0) {
        timerID = setTimeout(() => callback(), duration * 1000 * 60);
    }
}
